import {
  BaseStorageItem,
  ServiceProvider,
  StorageItemMetadata,
  UPLOADCAM_FOLDER_MIME,
} from '@uploadcam/common';

export interface ZohoFileResource {
  id: string;
  attributes: {
    name: string;
    type: string;
    modified_time?: string;
    parent_id?: string;
  };
}

const ZOHO_FOLDER_TYPES = new Set(['folder', 'teamfolder']);

export class ZohoItem extends BaseStorageItem {
  public readonly id: string;
  public readonly name: string;
  public readonly parentId: string | undefined;
  public readonly lastModified: Date | undefined;
  public readonly allowsSubfolderCreation: boolean;
  public readonly mime: string;

  constructor(resource: ZohoFileResource, allowsSubfolderCreation: boolean) {
    super();

    const attrs = resource.attributes;
    const isFolder = ZOHO_FOLDER_TYPES.has(attrs.type);

    this.id = resource.id;
    this.name = attrs.name;
    this.parentId = attrs.parent_id;
    this.lastModified = attrs.modified_time ? new Date(attrs.modified_time) : undefined;
    this.allowsSubfolderCreation = allowsSubfolderCreation;
    this.mime = isFolder ? UPLOADCAM_FOLDER_MIME : attrs.type;
  }

  get provider(): ServiceProvider {
    return ServiceProvider.Zoho;
  }

  get driveId(): string | undefined {
    return undefined;
  }

  get isVirtual(): boolean {
    return false;
  }

  get metadata(): StorageItemMetadata {
    return {};
  }

  get size(): number | undefined {
    return undefined;
  }
}
